const timeFormat = function (timestamp){
    if(timestamp === undefined || timestamp === "0001-01-01T00:00:00Z"){return ""}
    let date = new Date(timestamp);
    let str =
        (("000"+(date.getFullYear())).slice(-4))+
        "/"+(("0"+(date.getMonth() + 1)).slice(-2))+
        "/"+("0"+date.getDate()).slice(-2)+
        " "+("0"+date.getHours()).slice(-2)+
        ":"+("0"+date.getMinutes()).slice(-2)+
        ":"+("0"+date.getSeconds()).slice(-2)
    return str
}
export default timeFormat